import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { red } from '@mui/material/colors';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import styles from './ApplicationForm.module.scss';
import { useEffect, useState } from 'react';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import withComponentLoader from '../../../../hoc/withComponentLoader';
import { fetchPersonMetadata } from './79/_api';
import { validateDateString } from 'utils';

/**
 * Display component for additional metadata for the form
 * @param {Object} props component properties
 * @param {boolean} props.collapsible  flag to dictate whether to use an accordion view
 * @param {string} props.target  target user's identifier
 * @param {Function} props.setLoading  setter function for loading state
 * @returns Card or Accordion with additional metadata for the target user
 */
const PersonMetadata = ({
	collapsible,
	target,
	reportMetadata,
	setLoading,
}) => {
	const [expanded, setExpanded] = useState(true);
	const [isCollapsible, setIsCollapsible] = useState(collapsible);
	const [person, setPerson] = useState({});

	useEffect(() => {
		if (target) {
			fetchPersonMetadata(target).then(response => {
				setPerson(response);
				reportMetadata && reportMetadata(response);
				setLoading(false);
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [target]);

	useEffect(() => {
		setIsCollapsible(collapsible && person?.metadata?.length > 0);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [person]);

	const headerDetails = (
		<CardHeader
			avatar={
				<Avatar sx={{ bgcolor: red[500] }} aria-label='recipe'>
					{person?.initials || '??'}
				</Avatar>
			}
			title={person?.name || 'N/A'}
			subheader={
				expanded
					? validateDateString(person?.lastRequestedDate) ||
					  !!!person?.lastRequestedDate
						? `Last Requested: ${
								person?.lastRequestedDate || 'N/A'
						  }`
						: person?.lastRequestedDate
					: isCollapsible
					? 'Expand for more details...'
					: null
			}
		/>
	);

	const additionalDetails =
		person?.metadata?.length > 0
			? person?.metadata?.map(metadata => {
					return (
						<Typography
							color='text.secondary'
							key={'person_metadata_' + metadata.Key}
						>
							{metadata.Key}: {metadata.Value}
						</Typography>
					);
			  })
			: null;

	return person && person.name && person.name !== 'N/A' ? (
		isCollapsible ? (
			<Accordion
				expanded={expanded}
				onChange={() => setExpanded(!expanded)}
			>
				<AccordionSummary expandIcon={<ExpandLessIcon />}>
					{headerDetails}
				</AccordionSummary>
				<AccordionDetails
					className={styles['application-form__input-indention-1']}
				>
					{additionalDetails}
				</AccordionDetails>
			</Accordion>
		) : (
			<Card className={styles['application-form__section']}>
				{headerDetails}
				<CardContent
					className={styles['application-form__input-indention-1']}
				>
					{additionalDetails}
				</CardContent>
			</Card>
		)
	) : null;
};

export default withComponentLoader(PersonMetadata);
